<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="`/master-penjualan/item-penjualan-paket`"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Paket Produk
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <div class="fs-18 font-weight-bold black_one mb-6">
                        Informasi Paket
                      </div>
                      <v-row>
                        <v-col class="py-0" cols="6">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Nama`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Nama
                              </div>

                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                rounded
                                dense
                                outlined
                                hide-details
  
                                :color="set_color"
                                placeholder="Nama"
                                :error-messages="errors"
  
                                v-model="form.name"
                                
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.name !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Satuan`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Satuan
                              </div>
  
                              <v-autocomplete
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Pilih Satuan"
  
                                hide-details
                                clearable
  
                                :items="satuan"
                                item-text="name"
                                item-value="name"
                                :item-color="set_color"
  
                                v-model="form.satuan"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.satuan !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Kategori`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Kategori
                              </div>
  
                              <v-autocomplete
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Pilih Kategori"
  
                                hide-details
                                clearable
  
                                :items="allCategory"
                                item-text="name"
                                item-value="id"
                                :item-color="set_color"
  
                                v-model="form.category_id"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.category_id !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Stok Minimal`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Stok Minimal
                              </div>

                              <v-currency-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Stok Minimal"
                                :error-messages="errors"
  
                                v-model="form.stock_min"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.stock_min !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <!-- <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <div class="fs-18 font-weight-bold black_one mb-6">
                        Informasi Stok
                      </div>
                      <v-row>
                        <v-col class="py-0" cols="12">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Stok Minimal`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Stok Minimal
                              </div>

                              <v-currency-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Stok Minimal"
                                :error-messages="errors"
  
                                v-model="form.stock_min"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.stock_min !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6">
                          <ValidationProvider
                              :name="`Stok`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Stok
                              </div>

                              <v-currency-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Stok"
                                :error-messages="errors"
  
                                v-model="form.stock"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.stock !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card> -->

                  <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <div class="fs-18 font-weight-bold black_one mb-6">
                        Informasi Harga
                      </div>
                      <v-row>
                        <v-col class="py-0" cols="6">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Harga Beli`" 
                              rules="required|min_value:0" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Harga Beli
                              </div>

                              <v-currency-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Harga Beli"
                                :error-messages="errors"
  
                                v-model="form.hpp"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.hpp !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6">
                          <ValidationProvider
                              :name="`Harga Jual`" 
                              rules="required|min_value:0" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Harga Jual
                              </div>

                              <v-currency-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Harga Jual"
                                :error-messages="errors"
  
                                v-model="form.selling_price"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.selling_price !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <div class="fs-18 font-weight-bold black_one mb-6">
                        Informasi Diskon
                      </div>
                      <v-row>
                        <v-col class="py-0" cols="6">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Diskon`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Diskon
                              </div>

                              <v-select
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Pilih Diskon"
  
                                hide-details
                                clearable
  
                                :items="[{
                                  id: 'tidak',
                                  name: 'Tiada Diskon'
                                }, {
                                  id: 'persen',
                                  name: 'Persen'
                                }, {
                                  id: 'rupiah',
                                  name: 'Rupiah'
                                }
                                ]"
                                item-text="name"
                                item-value="id"
                                v-model="form.discount_type"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.discount_type !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-select>
                            </ValidationProvider>
                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6" v-if="form.discount_type === 'persen'">
                          <ValidationProvider
                              :name="`Diskon (Persen)`" 
                              rules="required|min_value:0|max_value:100" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Diskon (Persen)
                              </div>

                              <v-currency-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Diskon (Persen)"
                                :error-messages="errors"
                                suffix=" %"
  
                                v-model="form.discount_percent"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.discount_percent !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col class="py-0" cols="6" v-if="form.discount_type === 'rupiah'">
                          <ValidationProvider
                            :name="`Diskon (Rupiah)`" 
                            rules="required|min_value:0" 
                            v-slot="{ errors, valid }">
                            <div class="mb-2">
                              <span class="red--text">*</span>
                              Diskon (Rupiah)
                            </div>

                            <v-currency-field
                              v-on:keyup.enter="save()"
                              
                              outlined
                              rounded
                              dense
                              prefix="Rp. "

                              :color="set_color"
                              placeholder="Diskon (Rupiah)"
                              :error-messages="errors"

                              v-model="form.discount_value"
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.discount_value !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <div class="fs-18 font-weight-bold black_one mb-6">
                        Informasi Produk
                      </div>
                      <v-row>
                        <v-col class="py-0" cols="12">
                          <div class="mb-6">
                            <ValidationProvider
                              :name="`Pilih Produk`" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="mb-2">
                                <span class="red--text">*</span>
                                Pilih Produk
                              </div>

                              <v-autocomplete
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Pilih Produk"
  
                                hide-details
                                clearable
                                multiple
                                return-object
  
                                :items="product"
                                item-text="name"
                                item-value="id"
                                :item-color="set_color"
  
                                v-model="form.child_item_json"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.child_item_json !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </div>
                          <div class="mt-5" v-if="form.child_item_json.length > 0">
                            <table style="border: 1px solid #ededed; width: 100%;" class="table">
                              <tr>
                                <th style="font-size: 14px; z-index: 1; width: 50px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Aksi</th>
                                <th style="font-size: 14px; z-index: 1; width: 210px; min-width: 210px; max-width: 210px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">Nama Akun</th>
                                <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                  <div class="d-flex align-center">
                                    <div>
                                      Qty Stok
                                    </div>
                                    <!-- <div class="ml-auto">
                                      {{ add_total_debit | price }}
                                    </div> -->
                                  </div>
                                </th>
                                <th style="font-size: 14px; z-index: 1; width: 150px; min-width: 150px; max-width: 150px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                                  <div class="d-flex align-center">
                                    <div>
                                      Qty
                                    </div>
                                    <!-- <div class="ml-auto">
                                      {{ add_total_kredit | price }}
                                    </div> -->
                                  </div>
                                </th>
                              </tr>
                              <tr v-for="(item, index) in form.child_item_json" :key="index" @click="selected.add = (((`100${index}`) + index) + (index+1))" :class="selected.add === (((`100${index}`) + index) + (index+1)) ? 'selected' : ''">
                                <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; width: 50px; min-width: 50px; max-width: 50px; text-align: center;">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        min-width="36"
                                        rounded
                                        @click="form.child_item_json.splice(index, 1);"
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon small>mdi-trash-can-outline</v-icon>
                                        
                                      </v-btn>
                                    </template>
            
                                    <span>Hapus</span>
                                  </v-tooltip>
                                </td>
                                <td style="font-size: 12px; border: 1px solid #ededed; width: 210px; min-width: 210px; max-width: 210px; border-left: none; padding: 8px 12px; text-align: left;">
                                  {{ item.name }}
                                </td>
                                <td style="font-size: 12px; border: 1px solid #ededed; width: 150px; min-width: 150px; max-width: 150px; border-left: none; padding: 8px 12px; text-align: left;">
                                  {{ item.stock }}
                                </td>
                                <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150px; max-width: 150px; padding: 8px 12px; text-align: right;">
                                  <ValidationProvider
                                    :name="`Qty ${item.name}`" 
                                    :rules="`min_value:0|required|max_value:${item.stock}`" 
                                    v-slot="{ errors }">
                                    <v-currency-field
                                          
                                      
                                      rounded
                                      dense
                                      outlined
                                      hide-details
                
                                      :color="set_color"
                                      placeholder="Quantity"
                                      :error-messages="errors"

                                      
                
                                      v-model="item.qty"
                                      
                                      required
                                      style="border-radius: 10px;">
                                      <template v-slot:append-outer>
                                        <div v-if="errors.length > 0">
                                          <v-tooltip top color="#ff5252">
                                            <template v-slot:activator="{ on }">
                                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                            </template>
                                            
                                            {{ errors[0] }}
                                          </v-tooltip>
                                        </div>
                                        
                                        <div v-if="item.qty !== '' && valid">
                                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                                        </div>
                                      </template>
                                    </v-currency-field>
                                  </ValidationProvider>
                                </td>
                              </tr>
                            </table>
                            <!-- <v-divider class="my-2"></v-divider>
                            <v-row>
                              <v-col>
                                <div class="fs-17 font_weight_600 text-left black_one">
                                  Total Perkiraan Modal Belanja
                                </div>
                              </v-col>
                              <v-col>
                                <div class="fs-17 font_weight_600 text-right black_one">
                                  {{ total_nominal | price }}
                                </div>
                              </v-col>
                            </v-row> -->
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>

                  <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <div class="fs-18 font-weight-bold black_one mb-6">
                        Gambar Paket
                      </div>
                      <v-row>
                        <v-col class="py-0" cols="12">
                          <uploadfolder
                            v-model="upload.image" 
                            style="height: 250px; width: 250px">
                            <div 
                              slot="activator"
                              class="cursor-pointer">
                              <v-card 
                                flat
                                height="250"
                                class="d-flex align-center justify-center"
                                style="border-radius: 15px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;">
                                <div v-if="form.image_url.length < 1">
                                  <v-icon v-if="!process.image"
                                    size="60" 
                                    color="#718EBF">
                                    mdi-cloud-upload-outline
                                  </v-icon>
          
                                  <v-progress-circular v-else
                                    indeterminate
                                    :color="set_color">
                                  </v-progress-circular>
                                </div>
          
                                <v-img v-else
                                  contain
                                  height="250"
                                  :src="form.image_url" 
                                  :alt="form.image_url"
                                  class="text-center d-flex align-center">
                                  <div 
                                    class="d-flex aling-center justify-center" 
                                    style="width: 100%; height: auto;">
                                    <v-icon v-if="!process.image"
                                      size="60" 
                                      color="white">
                                      mdi-cloud-upload-outline
                                    </v-icon>
          
                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>
                                </v-img>
                              </v-card>
                            </div>
                          </uploadfolder>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
            cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <div v-if="message.error.length > 0"
                class="text-center mx-6 my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-space/>
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="#240087"
                class="body-2 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                :to="`/master-penjualan/item-penjualan-paket`"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        item: [],

        dialog: {
          form: false,
          fullscreen: false
        
        },
        menu: {
          
        },
        modalTime: {
          
        },
        total_nominal: 0,

        form: {
          outlet_id: '',
          par_id: '',

          category_id: '',
          satuan: '',
          name: '',
          type: '',
          image_url: '',
          stock: '',
          stock_min: '',
          selling_price: '',
          hpp: '',
          duration_minutes: '',
          discount_percent: '',
          discount_value: '',
          discount_type: 'tidak',
          child_item_json: []
        },
        detail: {
          number: '',
          date: '',
          status: ''
        },
        product: [],
        category: [],
        allCategory: [],
        satuan: [],
        selected: [],
        menu2: false,
        menu1: false,
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,
          load: false,

          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.image.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
      this.fetchCategory()
      this.fetchSatuan()
    },
    methods: {
      async fetch (data) {
        let params = {
          outlet_id: this.outlet.outlet_id,
          limit: 1000000000
        }
        
        await get('pos/item_sales/data_last_child', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.product = []
            res.results.data.map((item) => {
              this.product.push({
                ...item,
                qty: 0
              })
            })
          }
        })
      },
      async fetchCategory (data) {
        let params = {
          outlet_id: this.outlet.outlet_id,
          limit: 1000000000,
          is_active: '1',
          type: 'paket'
        }
        
        await get('pos/category/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.allCategory = res.results.data
          }
        })
      },
      async fetchSatuan (data) {
        let params = {
          // outlet_id: this.outlet.outlet_id,
          limit: 1000000000
        }
        
        await get('pos/satuan/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.satuan = res.results.data
          }
        })
      },
      changeType () {
        if(this.allCategory.length > 0) {
          this.category = this.allCategory.filter((item) => {
            return item.type === this.form.type
          })
        }
        this.form.category_id = ''
      },
      changeParent () {
        if(this.form.par_id === '' || this.form.par_id === null) {
          this.form.category_id = ''
          this.form.type = ''
        } else {
          this.product.map((item) => {
            if(item.id === this.form.par_id) {
              // this.form.category_id = item.category_id
              this.form.type = item.type
              this.changeTypeParent(item.category_id)
            }
          })
        }
      },
      changeTypeParent (id) {
        if(this.allCategory.length > 0) {
          this.category = this.allCategory.filter((item) => {
            return item.type === this.form.type
          })
        }
        this.form.category_id = id
      },
      changeTotal() {
        this.total_nominal = this.form.items.reduce((acc, item) => {
          return acc + (item.qty * item.purchase_price)
        }, 0)
      },
      changeHarga(index) {
        this.form.items[index].supplier.map((supplier) => {
          if(supplier.supplier_id === this.form.items[index].supplier_id) {
            this.form.items[index].purchase_price = supplier.purchase_price
            this.changeTotal()
          }
        })
      },

      reset () {
        this.selected = this.form.items
      },
      saveItem () {
        this.form.items = this.selected
        this.dialog.form = false
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`pos/item_sales/add_paket`, {
            data: {
                outlet_id: this.outlet.outlet_id,
                // par_id: this.form.par_id === '' || this.form.par_id === null ? '0' : this.form.par_id,
                category_id: this.form.category_id,
                satuan: this.form.satuan,
                name: this.form.name,
                image_url: this.form.image_url,
                // stock: this.form.stock,
                stock_min: this.form.stock_min,
                selling_price: this.form.selling_price,
                hpp: this.form.hpp,
                discount_percent: this.form.discount_type === 'persen' ? this.form.discount_percent : '',
                discount_value: this.form.discount_type === 'rupiah' ? this.form.discount_value : '',
                child_item_json: JSON.stringify(this.form.child_item_json.map((item) => {
                  return {
                    item_sales_id: item.id,
                    qty: item.qty
                  }
                })
              )
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: `/master-penjualan/item-penjualan-paket` })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>

<style>
table {
  border-collapse: collapse;
}
</style>